module.exports = __webpack_public_path__ + "img/paypal-color.1f8db6e9.svg";